import { Debug } from "./debugger";

export let settings = {};
export let name = "";

const toStyleString = (map, ignoringPrefix=[], onlyPrefix=[]) => {
	if (map === undefined) { return }
	if (!(typeof map === 'string')) { 
		var output = ""

		for (const [key, value] of Object.entries(map)) {
			if (value != "_") {

				if (ignoringPrefix.length == 0 && onlyPrefix.length == 0) {
					output += `${key}:${value}; `
				} else {

					if (ignoringPrefix.length == 0 && onlyPrefix.length != 0) {
						let matches = onlyPrefix.filter( p => key.startsWith(p))
						console.log(matches)
						if (matches.length > 0) {
							console.log("adding because it matches")
							output += `${key}:${value}; `
						}
					}

					if (ignoringPrefix.length != 0 && onlyPrefix.length == 0) {
						let matches = ignoringPrefix.filter( p => key.startsWith(p))
						console.log(matches)
						if (matches.length == 0) {
							console.log("adding because none match ignore")
							output += `${key}:${value}; `
						}
					}
				}
			}
		}

		return output
	}
	return map
}


export let addInspectable = (element, settings, isLive) => {
	if (element !== null) {
		let name = element.getAttribute("data-i-name")
		
		if (name in settings) {

			let styles = settings[name].style

			if ("custom" in settings[name]) {
				let customSettings = settings[name].custom
				Object.values(customSettings).forEach(customSettingsValues => {
					if ("style" in customSettingsValues) {
						const stylesTemplate = customSettingsValues.style
						const templateValue = customSettingsValues.value

						if (templateValue != "none") {
							for (const [key, value] of Object.entries(stylesTemplate)) {
								styles[key] = value.replace("{{value}}", templateValue)
							}
						} else {
							for (const [key, value] of Object.entries(stylesTemplate)) {
								styles[key] = "unset"
							}
						}


					}
				})
			}

			if (name == "page-container" && isLive) {
				element.style = toStyleString(styles,["background-"], [])
			} else {
				element.style = toStyleString(styles)
			}

			let isPaywallJSTouchElement = false
			let isPaywallJSPurchaseButton = false

			for (const [key, value] of Object.entries(settings[name])) {
				if (key != "style" && key != "name" && key != "custom")  {
					element[key] = value
					element.setAttribute(key, value)
					if (key.startsWith("data-pw")) {
						isPaywallJSTouchElement = true
					}

					if (key.startsWith("data-pw-purchase")) {
						isPaywallJSPurchaseButton = true
					}
				}

				if (isPaywallJSTouchElement) {
					element.classList.add('sw-button')
				}

				if (isPaywallJSPurchaseButton) {
					element.classList.add('sw-purchase-button')
				}

				if (key == "innerHTML" || key == "innerText") {
					element.setAttribute("data-pw-var", settings.name + "." + settings[name].name)
				}

				element.setAttribute("data-i-key", settings.name + "." + settings[name].name)
			}
		}
	}
}

export let addBodyInspectable = (settings) => {
	let element = document.getElementById('backgroundFix')
	let name = "page-container"
	if (name in settings) {
		if ("style" in settings[name]) {
			// settings[name].style["background-attachment"] = "fixed"
			element.style = toStyleString(settings[name].style, [], ["background-"])

			if ('background-color' in settings[name].style) {
				document.body.style = `background-color: ${settings[name].style["background-color"]};`
			}

		}
	}
}

export let addFooterInspectable = (settings) => {
	let footer = document.getElementById('swFooter')
	let footerContainer = document.getElementById('swFooterContainer')

	if ("footer" in settings) {
		if ("style" in settings["footer"]) {

			footer.style = toStyleString(settings["footer"].style, ["background-", "-webkit-backdrop", "backdrop"])

			if ('background-color' in settings["footer"].style) {
				footerContainer.style = toStyleString(settings["footer"].style, [], ["background-", "-webkit-backdrop", "backdrop"])
			}
		}
	}
}

export let elements = {

}